import { NavLink } from 'react-router-dom'
import clsx from 'clsx'

import styles from './Navigation.module.scss'
import useNavigation from './useNavigation'
import capitolNoirIcon from '../../images/capitol-noir-icon.jpg'

interface NavigationProps {
  alwaysShowNav?: boolean
}

const Navigation = (props: NavigationProps) => {
  const { alwaysShowNav = false } = props
  const { links, showMenu, handlers } = useNavigation()

  return (
    <nav className={clsx(styles.navigationRoot, showMenu && styles.showMenu)}>
      <ul>
        <li className={styles.logo}>
          <button
            type="button"
            className={styles.menuToggle}
            onClick={handlers.handleToggleMenu}
            aria-expanded={showMenu}
            aria-label="Toggle navigation menu"
            disabled={alwaysShowNav}
          >
            <img
              src={capitolNoirIcon}
              alt="Capitol Noir"
              aria-hidden="true"
              className={styles.menuIcon}
            />
          </button>
        </li>
        {links?.map(({ path, label, image }) => (
          <li
            key={path}
            className={clsx(
              styles.menuItem,
              (alwaysShowNav || showMenu) && styles.menuItemVisible
            )}
          >
            <NavLink
              to={path}
              exact={path === '/'}
              activeClassName={styles.active}
              className={styles.menuIcon}
            >
              <img src={image} alt={label} />
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default Navigation
